import Icon from '../../components/Icon.vue'

Icon.register({"brands/apple":{"width":376,"height":512,"paths":[{"d":"M314.7 268.7C314.5 232 331.1 204.3 364.7 183.9 345.9 157 317.5 142.2 280 139.3 244.5 136.5 205.7 160 191.5 160 176.5 160 142.1 140.3 115.1 140.3 59.3 141.2 0 184.8 0 273.5 0 299.7 4.8 326.8 14.4 354.7 27.2 391.4 73.4 481.4 121.6 479.9 146.8 479.3 164.6 462 197.4 462 229.2 462 245.7 479.9 273.8 479.9 322.4 479.2 364.2 397.4 376.4 360.6 311.2 329.9 314.7 270.6 314.7 268.7zM258.1 104.5C285.4 72.1 282.9 42.6 282.1 32 258 33.4 230.1 48.4 214.2 66.9 196.7 86.7 186.4 111.2 188.6 138.8 214.7 140.8 238.5 127.4 258.1 104.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/apple.js
// module id = YDNL
// module chunks = 0